import { Types, isInvalidType, isString } from './utilities';

export default (config) => (value) => {
  if (isString(value)) {
    // Extract flags from the regex
    const regexFlags = (config.regex.match(/\/([gimsuy]*)$/) || ['', ''])[1];

    // Add extracted flags to the RegExp object
    const regexWithFlags = new RegExp(
      config.regex.replace(/^\/|\/[gimsuy]*$/g, ''), // Remove leading '/' and trailing flags
      regexFlags,
    );
    return !regexWithFlags.test(value) ? config.message : null;
  }
  return isInvalidType(value, [Types.string]);
};
